import { useMutationTestSampleError } from "../hooks/mutations/useMutationTestSampleError.ts";

export default function Test() {
  const { mutate } = useMutationTestSampleError();

  return (
    <div className="p-12 flex flex-col gap-12">
      <button
        onClick={() => {
          throw new Error("Sample error thrown in component");
        }}
      >
        Throw sample error
      </button>
      <button
        onClick={() => {
          mutate();
        }}
      >
        Send API request that fails
      </button>
    </div>
  );
}
